import 'whatwg-fetch'
export default async function (...args) {
    const res = await window.fetch(...args);
    return await res.json()
}